/*
 *  Copyright (c) Qwoach LLC 2021. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 20/11/2021
 */


import MenuItem from "@/core/modules/coach/Resources/Files/QwoachDrive/MenuItem";

export default class SwitchMenuItem extends MenuItem {

	isSwitchedOn: boolean

	constructor(action: string, name: string, isSwitchedOn: boolean, isDivided: boolean) {
		super(action, name, null, isDivided, false);
		this.isSwitchedOn = isSwitchedOn
	}
}
